<p-card>
  <div>
    <vnm-floated-label-field label="il-class-enrol-card.sessions-label">
      <vnm-il-class-sessions-cell
        [sessions]="ilClass.ilSessions"
        onlyShow="nearest"
        [showLocation]="true"
        [hideLocationUrl]="true"
      ></vnm-il-class-sessions-cell>
    </vnm-floated-label-field>
  </div>

  <div>
    <vnm-floated-label-field label="il-class-enrol-card.instructors-label">
      <vnm-il-class-instructor
        *ngFor="let instructor of ilClass.instructors"
        [instructor]="instructor"
      ></vnm-il-class-instructor>
    </vnm-floated-label-field>
  </div>

  <vnm-flex-container class="align-items-center">
    <vnm-il-class-availability [ilClass]="ilClass"></vnm-il-class-availability>

    <button
      pButton
      type="button"
      [label]="buttonLabel"
      icon="fa fa-fw fa-plus"
      class="p-button-secondary"
      (click)="onSelectClass()"
      flex-end
    ></button>
  </vnm-flex-container>
</p-card>
